import {Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer, SimpleChanges, ViewChild} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {Observable, Subscription} from 'rxjs';
import {LoadingService} from '../../loading.service';
import {Course, CourseContent, CourseLecture} from '../../services/course-data.service';
import {State} from '../../state';
import {setCurrentLesson, setCurrentLessonItem} from '../../state/courses/actions';
import {selectCurrentCourse, selectCurrentLesson, selectCurrentLessonId} from '../../state/courses/selectors';

@Component({
	selector: 'app-lesson',
	templateUrl: './lesson.component.html',
	styleUrls: ['./lesson.component.less']
})
export class LessonComponent implements OnInit, OnDestroy  {

	@Input() courseId: string;
	@Input() lessonNumber: number;
	@Input() lessonId: string;
	@Input() lecture: CourseLecture;
	@Input() layout = 'card';

	selected = false;
	currentLessonId = null;
	currentLessonSub: Subscription;

	ignoreOpenItemSubmit = false; //TODO remove them when move to Angular/State based collapse

	@Output() activeLessonChange: EventEmitter<CourseLecture> = new EventEmitter<CourseLecture>();

	currentSelection = 'lecture';

	constructor(private loading: LoadingService, private store: Store<State>) {
		this.currentLessonSub = this.store.pipe(select(selectCurrentLessonId)).subscribe(s => this.currentLessonId = s);
	}

	ngOnInit() {}

	ngOnDestroy(): void {
		if (this.currentLessonSub && !this.currentLessonSub.closed) {
			this.currentLessonSub.unsubscribe();
		}
	}

	setSelection(event: any, type: string) {
		event.stopPropagation();

		//Tell the component to ignore the open function (about to be manually called) since we'll be handling it ourselves
		this.ignoreOpenItemSubmit = true; //TODO remove when move to state based collapse
		setTimeout(() => this.ignoreOpenItemSubmit = false, 50); //reenable the click handling

		const target = event.target || event.srcElement || event.currentTarget;
		const cardHeader = target.closest('.card-header');

		if (cardHeader.classList.contains('collapsed')) {
			cardHeader.click();
		}

		this.selected = !this.selected;
		this.currentSelection = type;

		// dispatch event indicating this element was selected
		let item: CourseContent;
		if (type === 'lecture' && this.lecture.video_id) {
			item = this.lecture;
			// } else if (type === 'qa' && this.lesson.supplementary_videos && this.lesson.supplementary_videos.length) {
			// 	item = this.lesson.supplementary_videos;
		}
		if (item) {
			this.store.dispatch(setCurrentLessonItem({itemType: type, item}));
		}
	}

	open(event) {
		//TODO replace this trash with a real angular component!!!
		const target = event.target || event.srcElement || event.currentTarget;
		const cardHeader = target.closest('.card-header');

		if (cardHeader.classList.contains('collapsed')) {
			const elem = this.lecture && this.lecture.video_id
				? this.lecture
				: null;
			if (elem) {
				this.store.dispatch(setCurrentLesson({currentLesson: this.lecture.url_slug}));
				//if we didn't get triggered by a type click //TODO when move to state-based collapse
				if (!this.ignoreOpenItemSubmit) {
					this.store.dispatch(setCurrentLessonItem({itemType: elem.system_type, item: elem}));
				}
			}

			setTimeout(() => {
				const yCoordinate = cardHeader.getBoundingClientRect().top + window.pageYOffset;
				const yOffset = -79;
				window.scrollTo({
					top: yCoordinate + yOffset,
					behavior: 'smooth'
				});
			}, 500);
		} else {
			this.store.dispatch(setCurrentLesson({currentLesson: null}));
			this.store.dispatch(setCurrentLessonItem({itemType: null, item: null}));
		}
	}
}
